import b from 'b_';
import cx from 'classnames';
import React, { ReactElement, RefObject } from 'react';

import Tab from './__tab/tabs__tab';
import { TABS_THEME } from './constants';

import './tabs.scss';

interface Props {
    children?: ReactElement | Array<ReactElement | null> | null;
    mix?: string;
    withDivider?: boolean;
    theme?: TABS_THEME;
    tabsRef?: RefObject<HTMLDivElement>;
    role?: React.AriaRole;
}

class Tabs extends React.Component<Props> {
    static Tab = Tab;
    static THEME = TABS_THEME;

    render() {
        const { children, mix, withDivider, theme, tabsRef, role } = this.props;

        return (
            <div className={cx(b('tabs', { 'with-divider': withDivider }), mix)} ref={tabsRef} role={role}>
                {theme && children
                    ? React.Children.map<ReactElement, ReactElement | null>(
                          children,
                          (child: ReactElement) => child && React.cloneElement(child, { theme })
                      )
                    : children}
            </div>
        );
    }
}

export default Tabs;
